import { FeatureConfig } from "@/types";

// 기존 코드와의 호환성을 위한 repository export
export const repository = {
  // 필요할 때 동적으로 생성
  get: () => null,
  post: () => null,
  put: () => null,
  delete: () => null,
};

// MenuTab.vue 파일이 존재하지 않으므로 임시로 주석 처리
// export const menuConfig: FeatureConfig[] = [
//   {
//     name: "Menu",
//     path: "/menu",
//     component: () => import("@/features/menu/components/MenuTab.vue"),
//     meta: {
//       currentMenu: "COM", // 공통관리 메뉴에 속함
//     },
//     // repositories는 필요할 때만 동적으로 생성
//     repositories: {
//       default: repository,
//     },
//   },
// ];

// 빈 배열로 설정하여 빌드 에러 방지
export const menuConfig: FeatureConfig[] = [];
